import React from "react";
import classNames from "classnames";
import Modal from "components/base/Modal";
import css from "./style.scss";

const BatchDialerAlert = ({ isOpen, onClose }) => {

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            isCloseButton={false}
            uniqId="push-to-BatchDialer"
            borderRadius="12px"
            modalClassName={css.pushtoBatchDialerModal}
            className={classNames(css.clsAccPageModals, css.clsBillingModal)}
        >
            <div className={css.modalContainer}>

                <div className={css.modalCard}>

                    <div className={css.content}>
                        <h3 className={css.title}>Push to BatchDialer</h3>

                        <p className={css.message}>
                            To use this feature, your company admin needs to set up a BatchDialer
                            account. Please contact your admin for assistance.
                        </p>
                    </div>
                    <div className={css.footer}>
                        <button
                            className={classNames(css.btn, css.okBtn)}
                            type="button"
                            onClick={() => onClose && onClose()}
                        >
                            Ok
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default BatchDialerAlert;